function formatAmount(amount) {
  const numericAmount = Number(amount);

  return (Number.isFinite(numericAmount) ? numericAmount : 0).toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default formatAmount;
